(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('NewBankAccount', [
			'$filter',
			'globalConfig',
			'InvestmentEntityFactory',
			'INVESTMENT_ENTITY_ID',
			'urlFactory',
			EditTrustAccountFunction
		]);

	function EditTrustAccountFunction(
		$filter,
		globalConfig,
		InvestmentEntityFactory,
		INVESTMENT_ENTITY_ID,
		urlFactory
	) {
		var newBankAccount = this;

		function buildPayload(){
			return {
				accountType: newBankAccount.accountType.value,
				bankName: newBankAccount.serializedForm.bankName,
				routingNumber: newBankAccount.serializedForm.routingNumber,
				accountNumber: newBankAccount.serializedForm.accountNumber,
				accountNumberConfirm: newBankAccount.serializedForm.accountNumberConfirm
			};
		}

		newBankAccount.handleContinue = function(){

			InvestmentEntityFactory.linkManualBankAccount(buildPayload(), newBankAccount.bankAccountForm)
				.then(function(){
					urlFactory.redirect("/account/investment-accounts/" + INVESTMENT_ENTITY_ID + "/" + newBankAccount.entityTypeIdentifier + "/bank-accounts/new/save");
				})
				.catch(function(){
					newBankAccount.formSubmitted = false;
				});
		};

		(function init() {
			angular.extend(newBankAccount, globalConfig);

			newBankAccount.accountType = angular.isDefined(newBankAccount.serializedForm.accountType) ? $filter('filter')(newBankAccount.bankAccountTypes, {'value': newBankAccount.serializedForm.accountType}, true)[0] : newBankAccount.bankAccountTypes[0];
		})();
	}
})(window.angular);